export default function PillarIntro({ n, overline, title, accent, description }) {
  return (
    <section
      className="section-padding bg-white border-b border-black/10"
      data-testid={`pillar-intro-${n}`}
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4">
              Säule {n} · {overline}
            </div>
            <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05]">
              {title}
              {accent && (
                <>
                  {" "}
                  <span className="text-[#D30000]">{accent}</span>
                </>
              )}
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg leading-relaxed text-[#4A4A52]">
              {description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
